import Header from './components/Header';
import Footer from './components/Footer';
import TitleSection from './components/TitleSection';
import AbstractSection from './components/AbstractSection';
import MotivationSection from './components/MotivationSection';
import SSAHSection from './components/SSAHSection';
import SAHSection from './components/SAHSection';
import LessIsMoreSection from './components/LessIsMoreSection';
import DiscussionSection from './components/DiscussionSection';
import CitationSection from './components/CitationSection';

function App() {
  return (
    <div className="App min-h-screen bg-white text-ink-800">
      <Header />
      <main>
        <TitleSection />
        <section id="abstract">
          <AbstractSection />
        </section>
        <section id="motivation">
          <MotivationSection />
        </section>
        <section id="ssah">
          <SSAHSection />
        </section>
        <section id="sah">
          <SAHSection />
        </section>
        <section id="lessismore">
          <LessIsMoreSection />
        </section>
        <section id="discussion">
          <DiscussionSection />
        </section>
        <section id="citation">
          <CitationSection />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default App;
